import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "../../shared/shared.module";
import { CoreModule } from "src/app/core/core.module";
import { TranslateModule } from "@ngx-translate/core";
import { GetPremiumComponent } from "./get-premium.component";
import { TablerIconComponent } from "angular-tabler-icons";
import { StripePaymentComponent } from "./stripe-payment.component.ts/stripe-payment.component";

@NgModule({
  declarations: [
    GetPremiumComponent,
    StripePaymentComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    SharedModule,
    CoreModule,
    TranslateModule,
    TablerIconComponent
  ],
  exports: [
    GetPremiumComponent,
    StripePaymentComponent
  ]
})
export class GetPremiumModule { }